import { Countries, Districts } from '../models/mapping';
import { ApiCommonParams } from '../models/app';
import { ColorsCodeToLabel } from '../models/mapping';
import data from '../public/colors/colors.json';
import colors_map from '../public/colors/colors_map.json';
import { getAPIClient } from '@/lib/api';

export const fetchColors = (): ColorsCodeToLabel => {
  return data;
};

export const fetchColorsForFilters = (): ColorsCodeToLabel => {
  return colors_map;
};

export const fetchCountries = async ({
  lang,
  country,
  token
}: ApiCommonParams): Promise<Countries> => {
  const apiClient = getAPIClient({ country });

  const config = {
    headers: {
      ['UYN-LANGUAGE']: lang,
      ['UYN-COUNTRY']: country,
      ['UYN-BEARER']: token
    }
  };

  try {
    const { data } = await apiClient.get(
      '/wp-json/uyn/v1/layout/contries-list',
      config
    );

    return data.countries;
  } catch (error) {
    return {};
  }
};

export const fetchDistricts = async ({
  country_code,
  lang,
  country,
  token
}: ApiCommonParams & { country_code: string }): Promise<Districts> => {
  const apiClient = getAPIClient({ country });

  const config = {
    headers: {
      ['UYN-LANGUAGE']: lang,
      ['UYN-COUNTRY']: country,
      ['UYN-BEARER']: token
    },
    params: {
      country_code
    }
  };

  try {
    const { data } = await apiClient.get(
      '/wp-json/uyn/v1/layout/states-list',
      config
    );

    return data.states;
  } catch (error) {
    return {};
  }
};
